import { render, staticRenderFns } from "./ProductListStockSync.vue?vue&type=template&id=4161582d&"
import script from "./ProductListStockSync.vue?vue&type=script&lang=ts&"
export * from "./ProductListStockSync.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports